var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03A1FFA7-2C7A-4C78-BE8C-D3BDD437A3C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POLARIS-4.2---Error-Message-(fireTV)",
    transform: "translate(-674.000000, -906.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(674.000000, 897.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "errorWhite",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,48 C10.745166,48 0,37.254837 0,24 C0,10.74516 10.745166,0 24,0 C37.25484,0 48,10.74516 48,24 C48,37.254837 37.25484,48 24,48 Z",
    id: "Clip-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.000001,14.3586141 L34.000001,16.8423199 L25.984923,24.85743 L34.000001,32.872511 L34.000001,34.35743 L32.515077,34.35743 L24.500001,26.342346 L16.484925,34.35743 L14.001184,34.35743 C14.0004147,34.3411845 14.000001,34.3249326 14.000001,34.3086803 L14.000001,34.3061611 C14.0003207,34.0378636 14.1028327,33.7696643 14.307537,33.56496 L23.015076,24.85743 L14.307537,16.14987 C14.1028327,15.9451702 14.0003207,15.6769716 14.000001,15.4086739 L14.000001,15.4061562 C14.0003207,15.1378584 14.1028327,14.8696598 14.307537,14.66496 C14.717589,14.25492 15.382413,14.25492 15.792462,14.66496 L24.500001,23.372499 L33.20754,14.66496 C33.4252816,14.4472184 33.7148709,14.3451031 34.000001,14.3586141 L34.000001,14.3586141 Z",
    id: "Clip-5",
    fill: "#D90909"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.5a0cf927.svg";
export { ForwardRef as ReactComponent };